import { useCallback } from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim/index.js';
import { useWeb3Onboard } from '../context.js';
export var useAppState = function useAppState() {
  var stateKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var web3Onboard = useWeb3Onboard();
  var _web3Onboard$state = web3Onboard.state,
      select = _web3Onboard$state.select,
      get = _web3Onboard$state.get;
  var subscribe = useCallback(function (onStoreChange) {
    var _ref = stateKey ? select(stateKey).subscribe(onStoreChange) : select().subscribe(onStoreChange),
        unsubscribe = _ref.unsubscribe;

    return function () {
      return unsubscribe;
    };
  }, [stateKey]);
  var getSnapshot = useCallback(function () {
    var snapshot = get();
    return stateKey ? snapshot[stateKey] : snapshot;
  }, [stateKey]);

  var getServerSnapshot = function getServerSnapshot() {
    return get() || getSnapshot;
  };

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};